import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { useTourDocument } from 'entities/tour/models/document'

import { HeaderGoBack } from 'shared/ui/header-go-back'
import { PageLoader } from 'shared/ui/page-loader'

import { DocumentState } from '../../ui/document-state'

import s from './styles.module.scss'

const DocumentTouristsPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { documentId } = useParams()
  const {
    data: document,
    isLoading,
    isError,
    refetch,
  } = useTourDocument(documentId)

  const handleGoBack = () => navigate(-1)

  if (document) {
    return (
      <main className={s.page}>
        <HeaderGoBack
          isFixed={false}
          variant="grey"
          buttonWhite
          onGoBack={handleGoBack}
        >
          <h1 className="bold-16">{t('tourDetails.tourists')}</h1>
        </HeaderGoBack>

        <section className={s.card}>
          {document.passengers.length ? (
            <ul className={s.list}>
              {document.passengers.map((passenger, index) => (
                <li
                  className={s.tourist}
                  key={passenger.id}
                >
                  <span className="semi-bold-14">{passenger.fullName}</span>
                  <span className="medium-14">
                    {t(
                      passenger.isCurrentUser
                        ? 'tourDetails.you'
                        : passenger.isCustomer
                          ? 'tourDetails.customer'
                          : 'tourDetails.participant',
                      { number: index + 1 },
                    )}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="regular-14">{t('tourDetails.noTourists')}</p>
          )}
        </section>
      </main>
    )
  }

  if (documentId && isLoading) return <PageLoader />

  if (!documentId || isError || !document) {
    return (
      <DocumentState
        onGoBack={handleGoBack}
        onRetry={() => void refetch()}
      />
    )
  }

  return null
}

export default DocumentTouristsPage
